import * as React from 'react';
import './index.module.scss';

export const StepPage = ({ children }) => {
    return <div styleName="step-page">{children}</div>;
};

export const StepPageHeader = ({ children }) => {
    return (
        <div styleName="header-wrapper">
            <div styleName="header">{children}</div>
        </div>
    );
};

export const StepPageBody = ({ children }) => {
    return <div styleName="body">{children}</div>;
};

export const StepPageMain = ({ children }) => {
    return <div styleName="page-main">{children}</div>;
};

export const StepPageSide = ({ children }) => {
    return <div styleName="sidebar">{children}</div>;
};
